import SidebarShare from './components/UIComponents/SidebarSharePlugin'
export default {
  install(Vue, router) {
    Vue.component('sidebar-share', SidebarShare);
  }
}
